import {React, useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import UseMediaQuery from "./UseMediaQuery";

function CategoryFooter()
{
    const [categories, setCategories] = useState([
        { id: 136, name: "محصولات جدید"},
        { id: 52, name: "فیروزه" },
        { id: 53, name: "جید" },
        { id: 156, name: "مروارید" }
    ]); // مقداردهی اولیه با داده‌های غیرواقعی
    const isMobile = UseMediaQuery("(max-width: 768px)");

    useEffect(() => {
        
    }, []);
    
    return(
        <div className="category-footer-section d-grid mt-4">
             {categories.map((category, index) => (
                <Link to={`/${category.id}-${category.name}`} className="category-box g-col-2 d-flex flex-column align-items-center rounded-3 justify-content-center" key={index}>
                    <img src={isMobile?require(`../img/categoryfooter/m_thumnail_${index+1}.png`):require(`../img/categoryfooter/thumnail_${index+1}.png`)}></img>
                    <span>{category.name}</span>
                </Link>
            ))}
        </div>
    );
}
export default CategoryFooter;